import Event from '@nl/event';

export const event = new Event();

export const EVENT_TYPES = {
	// Player Events
	PLAYER_READY: 'PLAYER_READY',
	PLAYER_COMPLETED: 'PLAYER_COMPLETED',
	PLAYER_CONTINUE_PLAY: 'PLAYER_CONTINUE_PLAY',
	PLAYER_LIVE_COMPLETED: 'PLAYER_LIVE_COMPLETED',
	PLAYER_UNSUPPORTED: 'PLAYER_UNSUPPORTED',
	PLAYER_GO_LIVE: 'PLAYER_GO_LIVE',
	PLAYER_PLAY_VIDEO: 'PLAYER_PLAY_VIDEO',
	PLAYER_PAGE_VIDEO: 'PLAYER_PAGE_VIDEO',
	PLAYER_AUTH_VIDEO: 'PLAYER_AUTH_VIDEO',
	PLAYER_PLAY_CHANNEL: 'PLAYER_PLAY_CHANNEL',
	PLAYER_PLAY_CHANNEL_LIVE_CONTINUE: 'PLAYER_PLAY_CHANNEL_LIVE_CONTINUE',
	PLAYER_PLAY_EVENT: 'PLAYER_PLAY_EVENT',
	PLAYER_PLAYLIST_COMPLETED: 'PLAYER_PLAYLIST_COMPLETED',
	PLAYER_PAUSE_PLAY: 'PLAYER_PAUSE_PLAY',
	PLAYER_STOP_PLAY: 'PLAYER_STOP_PLAY',
	PLAYER_RESUME_PLAY: 'PLAYER_RESUME_PLAY',
	PLAYER_REPLAY: 'PLAYER_REPLAY',
	PLAYER_COMPLETED_TO_NEXT: 'PLAYER_COMPLETED_TO_NEXT',
	PLAYER_PCM_CALLBACK: 'PLAYER_PCM_CALLBACK',
	PLAYER_PLAY_VIDEO_OR_AUDIO: 'PLAYER_PLAY_VIDEO_OR_AUDIO',
	PLAYER_ENTER_FULL_SCREEN: 'PLAYER_ENTER_FULL_SCREEN',
	PLAYER_EXIT_FULL_SCREEN: 'PLAYER_EXIT_FULL_SCREEN',
	PLAYER_PLAYING_NEXT_IS_LAST: 'PLAYER_PLAYING_NEXT_IS_LAST',
	PLAYER_UPID_UPDATED: 'PLAYER_UPID_UPDATED',
	PLAYER_GET_PLAYING: 'PLAYER_GET_PLAYING',
	PLAYER_DISPATCH_PLAYING: 'PLAYER_DISPATCH_PLAYING',

	// Channel Events
	CHANNEL_LIVE_CHANGED: 'CHANNEL_LIVE_CHANGED',
	CHANNEL_SEEK_TIME_EPG: 'CHANNEL_SEEK_TIME_EPG',
	CHANNEL_GET_LIVE_EPG: 'CHANNEL_GET_LIVE_EPG',
	CHANNEL_DISPATCH_LIVE_EPG: 'CHANNEL_DISPATCH_LIVE_EPG',
	CHANNEL_PREV_PLAYING_CHANGED: 'CHANNEL_PREV_PLAYING_CHANGED',
	CHANNEL_BLACKOUT_END: 'CHANNEL_BLACKOUT_END',

	// Auth Events
	CHECK_AUTH_START: 'CHECK_AUTH_START',
	CHECK_AUTH_COMPLETED: 'CHECK_AUTH_COMPLETED',
	USER_STATUS_COMPLETED: 'USER_STATUS_COMPLETED',
	NBA_AUTHENTICATED_METADATA: 'NBA_AUTHENTICATED_METADATA',
	NBA_NOT_AUTHENTICATED: 'NBA_NOT_AUTHENTICATED',
	DTC_AUTHENTICATED: 'DTC_AUTHENTICATED',
	NBA_DTC_AUTHENTICATED: 'NBA_DTC_NOT_AUTHENTICATED',
	NBA_DTC_NOT_AUTHENTICATED: 'NBA_DTC_NOT_AUTHENTICATED',

	// Subscription page
	DTC_LOGGEDIN: 'DTC_LOGGEDIN',
	CANCEL_SUBSCRIBE: 'CANCEL_SUBSCRIBE',

	// Free Sample Events:
	FREE_SAMPLE_START: 'FREE_SAMPLE_START',
	FREE_SAMPLE_END: 'FREE_SAMPLE_END',

	// MyAccount Events
	CONFIG_DATA_READY: 'CONFIG_DATA_READY',
	CONFIG_DATA_GET: 'CONFIG_DATA_GET',
	CONFIG_DATA_DISPATCH: 'CONFIG_DATA_DISPATCH',

	// Player Section UI Updated Events
	PLAYING_INFO_HEIGHT_UPDATED: 'PLAYING_INFO_HEIGHT_UPDATED',
	PLAYER_DOM_HEIGHT_UPDATED: 'PLAYER_DOM_HEIGHT_UPDATED',

	// Tracking Events
	TRACK_SUBSCRIPTION_PAGE_READY: 'TRACK_SUBSCRIPTION_PAGE_READY',
	TRACK_SUBSCRIPTION_START: 'TRACK_SUBSCRIPTION_START',
	TRACK_SUBSCRIPTION_SUCCESSFUL: 'TRACK_SUBSCRIPTION_SUCCESSFUL',
	TRACK_FAVORITE_PLAYER_ADDED: 'TRACK_FAVORITE_PLAYER_ADDED',
	TRACK_FAVORITE_PLAYER_REMOVED: 'TRACK_FAVORITE_PLAYER_REMOVED',
	TRACK_FAVORITE_TEAM_ADDED: 'TRACK_FAVORITE_TEAM_ADDED',
	TRACK_FAVORITE_TEAM_REMOVED: 'TRACK_FAVORITE_TEAM_REMOVED',
	TRACK_VIDEO_SEARCH_EVENT: 'TRACK_VIDEO_SEARCH_EVENT',
	TRACK_VIDEO_SEARCH_RESULTS_SORT: 'TRACK_VIDEO_SEARCH_RESULTS_SORT',
	TRACK_VIDEO_LIST_FILTER_UPDATE: 'TRACK_VIDEO_LIST_FILTER_UPDATE',
	TRACK_PACKAGE_SELECT: 'TRACK_PACKAGE_SELECT',
	TRACK_PROMO_CODE_CHECK: 'TRACK_PROMO_CODE_CHECK',

	// Favorite Page Event
	ACCOUNT_PAGE_PATHNAME_CHANGED: 'ACCOUNT_PAGE_PATHNAME_CHANGED',

	// Custom Events
	VIDEO_DETAIL_NBA_FEED_READY: 'VIDEO_DETAIL_NBA_FEED_READY',
};

// MyAccount/Secure: export event and EVENT_TYPES to pages
if (window.location && /^(\/account\/|\/secure\/|\/packages\/|\/streaming-subscriptions\/)/.test(window.location.pathname)) {
	// eslint-disable-next-line no-underscore-dangle
	window.__NL__ = window.__NL__ || {};
	// eslint-disable-next-line no-underscore-dangle
	window.__NL__.event = event;
	// eslint-disable-next-line no-underscore-dangle
	window.__NL__.EVENT_TYPES = EVENT_TYPES;
}
